import { BRAND } from "../config/brand";

/**
 * The real SkillSyncs logomark (same icon used for the favicon / app icon),
 * used anywhere a compact brand mark is needed next to the wordmark.
 *
 * This replaces the old placeholder "initials in a coloured square" badge.
 * Pass `boxed` when placing the mark on a dark background (e.g. the Login /
 * Signup branding panels) so it keeps a white tile behind it for contrast;
 * on light backgrounds the mark is shown directly with no container.
 */
function BrandMark({ size = 32, boxed = false, rounded = "rounded-lg", className = "" }) {
  const img = (
    <img
      src="/logo192.png"
      alt={`${BRAND.name} logo`}
      className="h-full w-full object-contain"
    />
  );

  if (!boxed) {
    return (
      <span
        className={`inline-flex flex-shrink-0 ${className}`}
        style={{ width: size, height: size }}
      >
        {img}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex flex-shrink-0 items-center justify-center bg-white ${rounded} p-1.5 ${className}`}
      style={{ width: size, height: size }}
    >
      {img}
    </span>
  );
}

export default BrandMark;
